/**
 * Timer v1 HTTP client — see backend/neko-timer-v1-service/ and docs/timer-v1-rollout.md
 */
import {getTimerV1ApiBaseUrl} from "@/config/timerV1Config";

const REQ_MS = 8000;

function authHeaders() {
  const h = {Accept: "application/json", "Content-Type": "application/json"};
  try {
    const token = localStorage.getItem("token");
    if (token) h.Authorization = `JWT ${token}`;
  } catch {
    /* ignore */
  }
  return h;
}

function joinApi(path) {
  const base = getTimerV1ApiBaseUrl();
  const p = String(path || "").replace(/^\//, "");
  return `${base}${p}`.replace(/([^:]\/)\/+/g, "$1");
}

async function request(method, path, body) {
  const ctrl = new AbortController();
  const t = setTimeout(() => ctrl.abort(), REQ_MS);
  try {
    const r = await fetch(joinApi(path), {
      method,
      cache: "no-store",
      credentials: "omit",
      mode: "cors",
      headers: authHeaders(),
      body: body != null ? JSON.stringify(body) : undefined,
      signal: ctrl.signal,
    });
    clearTimeout(t);
    const ct = (r.headers.get("content-type") || "").toLowerCase();
    let data = null;
    if (ct.includes("application/json")) {
      try {
        data = await r.json();
      } catch {
        data = null;
      }
    }
    if (!r.ok) {
      const detail =
        (data && (data.detail || data.message)) || `HTTP ${r.status}`;
      const err = new Error(detail);
      err.status = r.status;
      throw err;
    }
    return data;
  } catch (e) {
    clearTimeout(t);
    throw e;
  }
}

export async function fetchTimerV1Version() {
  return request("GET", "api/timer/v1/version/");
}

/** @returns {object|null} active session */
export async function fetchMyActiveSession() {
  const data = await request("GET", "api/timer/v1/sessions/me/");
  return data && data.active ? data.active : null;
}

export async function fetchActiveRoster() {
  const data = await request("GET", "api/timer/v1/sessions/active/");
  return (data && data.sessions) || [];
}

export async function startSession(payload = {}) {
  const data = await request("POST", "api/timer/v1/sessions/start/", payload);
  return data && data.session;
}

export async function stopSession(payload = {}) {
  const data = await request("POST", "api/timer/v1/sessions/stop/", payload);
  return data && data.session;
}

export async function linkLegacyLog(sessionId, legacyTimerLogId) {
  const sid = encodeURIComponent(String(sessionId || ""));
  return request("PATCH", `api/timer/v1/sessions/${sid}/legacy/`, {
    legacy_timer_log_id: legacyTimerLogId,
  });
}
